import React from "react";
import Slider from "react-slick";

const Banner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="banner-container">
      <Slider {...settings}>
        <div>
          <img src="/images/banner1.jpg" alt="Banner 1" style={{ width: "100%" }} />
        </div>
        <div>
          <img src="/images/banner2.jpg" alt="Banner 2" style={{ width: "100%" }} />
        </div>
      </Slider>
    </div>
  );
};

export default Banner;